import "../css/style.scss"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import './general'
import './load-more'
import './scroll-effects'
import './apis/index'
import './highlight'
import './swiper-settings'